import CatalogTrack from '@common/types/catalog/catalog-track';

export interface TrackCollaborators {
  collaborators: {
    id: string;
    name: string;
    avatar?: string;
    type: string;
  }[];
  contributors: {
    id: string;
    name: string;
    avatar?: string;
    type: string;
  }[];
}

export const getTrackCollaborators = (
  track: CatalogTrack,
  artistId?: string
): TrackCollaborators => {
  return (
    track.collaborators?.reduce(
      (acc: TrackCollaborators, collaboratorItem) => {
        if (collaboratorItem.id === artistId) {
          return acc;
        }

        if (collaboratorItem.type === 'COLLABORATOR') {
          acc.collaborators.push(collaboratorItem);
        }
        if (collaboratorItem.type === 'CONTRIBUTOR') {
          acc.contributors.push(collaboratorItem);
        }

        return acc;
      },
      { collaborators: [], contributors: [] }
    ) || { collaborators: [], contributors: [] }
  );
};
